import styled from 'styled-components';
import { ShadowBoxDark as DarkShadowBox, TitleAccent as AccentTitle } from 'app/components';

export const TitleAccent = styled(AccentTitle)`
  margin: ${({ theme }) => `0 ${theme.indent.s} ${theme.indent.m}`};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    font-size: 1.6rem;
    line-height: 1.5;
    letter-spacing: 1.5px;
  }
`;

export const ShadowBoxDark = styled(DarkShadowBox)`
  padding: ${({ theme }) => `${theme.indent.m} ${theme.indent.s}`};

  .b-no-content {
    padding: ${({ theme }) => `60px ${theme.indent.m} 76px`};
    box-shadow: none;

    &__text {
      text-transform: none;
    }
  }
`;

export const FavoriteMovie = styled.div`
  position: relative;
  margin: ${({ theme }) => `0 ${theme.indent.s}`};

  & > a {
    display: block;
  }

  .b-image-with-loader {
    width: 100%;
  }

  .b-image-with-loader__inner {
    background-color: ${({ theme }) => theme.color.borderDark};
  }
`;
